module.exports = __webpack_public_path__ + "img/t6-black.7e247d19.png";